import { User } from '../../models/user';

export const getUserNames = (users: User[]): string => {
  let userName = '';
  users.forEach(user => {
    if (user !== null) {
      if (userName !== '') userName += ', ';
      userName += ((user.firstName === null || user.lastName === null)
        || (user.firstName === undefined || user.lastName === undefined)
        || (user.firstName.length === 0 || user.lastName.length === 0))
        ? user.emailAddress
        : `${user.lastName}, ${user.firstName}`;
    }
  });
  return userName;
}
